import React from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";
import SignupFirstStep from "../FirstStep";
import SignupSecondStep from "../SecondStep";

export default class SignupStepper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stepIndex: 0
    };
  }

  handleNext = () => {
    const {stepIndex} = this.state;
    if (stepIndex === 0) {
      this.props.onAbandon();
    }
    if (stepIndex < 1) {
      this.setState({stepIndex: stepIndex + 1});
    }
  };

  handlePrev = () => {
    const {stepIndex} = this.state;
    if (stepIndex > 0) {
      this.setState({stepIndex: stepIndex - 1});
    }
  };

  canGoToStep2 = () => {
    const {first_name, last_name, account_name, email, password} = this.props.data;
    return !!(first_name && last_name && account_name && email && password);
  };

  canGoToStep3 = () => {
    return this.props.data.address.length && this.canGoToStep2();
  };

  render() {
    const {data, fetching, onChange, onSubmit} = this.props;
    const {stepIndex} = this.state;
    return (
      <React.Fragment>
        <Stepper activeStep={stepIndex}>
          <Step>
            <StepButton
              onClick={() =>
                this.setState({
                  stepIndex: 0
                })
              }>
              Account Setup
            </StepButton>
          </Step>
          <Step>
            <StepButton
              onClick={() =>
                this.setState({
                  stepIndex: 1
                })
              }>
              Facility Setup
            </StepButton>
          </Step>
        </Stepper>
        <div>
          {stepIndex === 0 && <SignupFirstStep fetching={fetching} data={data} onChange={onChange} />}
          {stepIndex === 1 && <SignupSecondStep fetching={fetching} data={data} onChange={onChange} />}
          <div className="row end-xs middle-xs" style={{marginTop: 12}}>
            <div className="col-sm" style={{textAlign: "left"}}>
              Already have an account?&nbsp;
              <Link to="/login">Log In</Link>
            </div>
            <div className="col-sm">
              <Button disabled={stepIndex === 0} color="primary" onClick={this.handlePrev} style={{marginRight: 12}}>
                Back
              </Button>
              <Button
                disabled={stepIndex === 0 ? !this.canGoToStep2() : true}
                color="primary"
                onClick={this.handleNext}
                style={{marginRight: 12}}>
                Next
              </Button>
              <Button variant="contained" color="primary" onClick={onSubmit} disabled={!this.canGoToStep3()}>
                Finish Signup!
              </Button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Signup/Stepper/index.jsx